import "./navbar.css"
import { FaMagnifyingGlass } from "react-icons/fa6";
import { FaBars } from "react-icons/fa6";
import { FaVest } from "react-icons/fa6";
import { AiOutlineUser } from "react-icons/ai";
import { AiOutlineDown } from "react-icons/ai";
import { FaBasketShopping } from "react-icons/fa6";
import { FaX } from "react-icons/fa6";
import { Link } from "react-router-dom"
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../context";
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

function Navbar() {
    const user = useAuthUser()
    const {cart ,totalFilter ,setTotalFilter} = useGlobalContext()
    const navigate = useNavigate()
    const [productsMegaMenu, setProductsMegaMenu] = useState(false)
    const [aboutus, setAboutus] = useState(false)
    const [clothes, setClothes] = useState(false)
    const [collection, setCollection] = useState(false)
    const [accesory, setAccesory] = useState(false)
    const [unqProducts, setUnqProducts] = useState(false)
    const [contactus, setContactus] = useState(false)
    const [opensidebar, setOpensidebar] = useState(false)
    const [search ,setSearch] = useState("")
    return (
        <div className="navbar">
            <div className="navbar-container">
                <div className="navbar-right" onClick={() => setOpensidebar(true)}>
                    <FaBars size={25} />
                </div>
                <div className={opensidebar ? "navbar-center open" : "navbar-center"}>
                    <div className="close-menu" onClick={() => setOpensidebar(false)}>
                        <FaX size={25} />
                    </div>
                    <div className="searchbox">
                        <FaMagnifyingGlass size={20} onClick={async () => {
                            try{
                                setTotalFilter({...totalFilter , search : search})
                                setOpensidebar(false)
                                navigate("/products")
                            }catch(err){
                                navigate("/error")
                            }
                        }}/>
                        <input onChange={(e)=> {
                            setSearch(e.target.value)
                            setTotalFilter({...totalFilter ,  search : e.target.value})
                        }} onKeyUp={async (e) => {
                            if(e.code == "Enter"){
                                try{
                                    setOpensidebar(false)
                                    setTotalFilter({...totalFilter , search : search})
                                    navigate("/products")
                                }
                                catch(err){
                                    navigate("/error")
                                }
                            }
                        }} type="search" placeholder="جستجو..." />
                    </div>
                    <nav>
                        <ul>
                            <li>
                                <Link to={"/"}>
                                    صفحه اصلی
                                </Link>
                            </li>
                            <li className={productsMegaMenu ? "submenu open" :"submenu"}>
                                <span style={{ width: "100%" }} onClick={() => setProductsMegaMenu(!productsMegaMenu)}>
                                    <Link to={"/products"}>
                                        محصولات
                                    </Link>
                                    <AiOutlineDown size={13} color="gray" />
                                </span>
                                <div className="megamenu">
                                    <div className="megamenu-row">
                                        <div className={clothes ? "megamenu-item open" :"megamenu-item"}>
                                            <span onClick={() => setClothes(!clothes)}>
                                                پوشاک
                                                <AiOutlineDown size={13} color="gray" />
                                            </span>
                                            <ul>
                                                <li>کت و دامن </li>
                                                <li>کت و دامن </li>
                                                <li>کت و دامن </li>
                                                <li>کت و دامن </li>
                                                <li>کت و دامن </li>
                                                <li>کت و دامن </li>
                                                <li>کت و دامن </li>
                                                <li>کت و دامن </li>
                                                <li>کت و دامن </li>
                                                <li>کت و دامن </li>
                                            </ul>
                                        </div>
                                        <div className={collection ? "megamenu-item open" :"megamenu-item"}>
                                            <span onClick={() => setCollection(!collection)}>
                                                کلکسیون
                                                <AiOutlineDown size={13} color="gray" />
                                            </span>
                                            <ul>
                                                <li>Nowruz 1403</li>
                                                <li>Nowruz 1403</li>
                                                <li>Nowruz 1403</li>
                                                <li>Nowruz 1403</li>
                                                <li>Nowruz 1403</li>
                                            </ul>
                                        </div>
                                        <div className={accesory ? "megamenu-item open" :"megamenu-item"}>
                                            <span onClick={() => setAccesory(!accesory)}>
                                                اکسسوری
                                                <AiOutlineDown size={13} color="gray" />
                                            </span>
                                            <ul>
                                                <li>گوشواره</li>
                                                <li>گوشواره</li>
                                                <li>گوشواره</li>
                                                <li>گوشواره</li>
                                            </ul>
                                        </div>
                                        <div className={unqProducts ? "megamenu-item open" :"megamenu-item"}>
                                            <span onClick={() => setUnqProducts(!unqProducts)}>
                                                محصولات ویژه
                                                <AiOutlineDown size={13} color="gray" />
                                            </span>
                                            <ul>
                                                <li>شگفت انگیز ها</li>
                                                <li>شگفت انگیز ها</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>فرشگاه ما</li>
                            <li>باشگاه مشتریان</li>
                            <li className={aboutus ? "submenu open" :"submenu"}>
                                <span style={{ width: "100%" }} onClick={() => setAboutus(!aboutus)}>
                                    درباره ما
                                    <AiOutlineDown size={13} color="gray" />
                                </span>
                                <div className="megamenu">
                                    <div className="megamenu-row">
                                        <div className={contactus ? "megamenu-item open" :"megamenu-item"}>
                                            <span onClick={() => setContactus(!contactus)}>
                                                تماس با ما
                                                <AiOutlineDown size={13} color="gray" />
                                            </span>
                                            <ul>
                                                <li>همکاری با ما</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </nav>
                    |
                    
                </div>
                <div className="navbar-left">
                    <div className="login">
                        <AiOutlineUser size={25} />
                        <Link style={{ color: "black" }} to={"/profile"}>{user ? user.username : "ورود"}</Link>
                    </div>
                    |
                    <div className="nav-cart-icon">
                        <FaBasketShopping size={25} color="green" />
                        <span className="qty-pro-in-cart">{cart.length}</span>
                        <Link to={"/cart"} style={{ margin: "0 5px", color: "black" }}>سبدخرید</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar;